var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"primary-fill","d":"M6.3,18.1c7.5,0,11.7-6.3,11.7-11.7c0-0.2,0-0.4,0-0.5c0.8-0.6,1.5-1.3,2-2.1c-0.7,0.3-1.5,0.5-2.4,0.6\n\tc0.9-0.5,1.5-1.3,1.8-2.3c-0.8,0.5-1.7,0.8-2.6,1C15.3,1.5,12.7,1.4,11,3C10,4,9.5,5.5,9.8,6.9C6.5,6.7,3.5,5.2,1.4,2.6\n\tC0.3,4.5,0.9,6.9,2.7,8.1C2,8.1,1.4,7.9,0.8,7.6c0,0,0,0,0,0.1c0,2,1.4,3.6,3.3,4c-0.6,0.2-1.2,0.2-1.9,0.1c0.5,1.7,2.1,2.8,3.8,2.8\n\tc-1.5,1.1-3.2,1.8-5.1,1.8c-0.3,0-0.7,0-1-0.1C1.9,17.5,4.1,18.1,6.3,18.1"}));
}

Twitter.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 20 20","style":{"enableBackground":"new 0 0 20 20"},"xmlSpace":"preserve"};

module.exports = Twitter;

Twitter.default = Twitter;
